import _ from 'lodash';
import {
    BudgetProposalT,
    ResourceNameField,
} from 'routes/BudgetModule/config/types';
import { ColDef } from 'ag-grid-community';
import { PROJECT_ID } from 'routes/BudgetModule/config/constants';
import {
    getInscriptionGridPhaseColumn,
    getInscriptionGridBudgetProposalColumn,
    InscriptionsGridDataT,
} from 'routes/BudgetModule/components/shared/InscriptionsGrid/gridHelpers';

export const getInscriptionsGridColumnsForOperation360 = (
    t: TranslationT,
    resourceType: Extract<
        ResourceNameField,
        'orgChartFinance.tree' | 'gestionnaire.name'
    >,
    budgetProposals: BudgetProposalT[],
): ColDef[] => {
    const serviceColumn = {
        field: resourceType,
        valueGetter: ({ data }: { data?: InscriptionsGridDataT }) =>
            data?.inscription[resourceType],
        width: 150,
        enableRowGroup: true,
    };
    const budgetProposalColumn = getInscriptionGridBudgetProposalColumn(
        t,
        budgetProposals,
    );
    const phaseColumn = getInscriptionGridPhaseColumn(t);

    return [serviceColumn, budgetProposalColumn, phaseColumn].map((column) => ({
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'textFloatingFilter',
        ...column,
    }));
};

export const getOrderedColumns = (
    columns: ColDef[],
    resourceType: ResourceNameField,
): ColDef[] => {
    const order = [
        'details',
        'status',
        'amount',
        'comment',
        resourceType,
        'budgetProposal',
        'phase',
        'imputation',
        PROJECT_ID,
        'actions',
    ];
    return _.sortBy(columns, (obj) => _.indexOf(order, obj.field));
};
